'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetFields = exports.setValues = exports.setValue = undefined;
var _constants = require('../constants');

// Update field
// https://reactjs.org/docs/forms.html#controlled-components
var setValue = exports.setValue = function setValue(formId, name, value) {
  return {
    type: _constants.actionTypes.SET_VALUE,
    formId: formId,
    name: name,
    value: value
  };
};

// Update multiple fields
var setValues = exports.setValues = function setValues(formId, values) {
  return {
    type: _constants.actionTypes.SET_VALUES,
    formId: formId,
    values: values
  };
};

// Reset array of fields to defaults
var resetFields = exports.resetFields = function resetFields(formId, fields) {
  return {
    type: _constants.actionTypes.RESET_FIELDS,
    formId: formId,
    fields: fields
  };
};